import axios from '@/api/$axios'
export default {
  list ({ courseId, video, page, perPage, kw }) {
    return axios.get(`/courses/${courseId}/characters`, {
      params: {
        video, page, perPage, title: kw
      }
    })
  },
  detail ({ id }) {
    return axios.get(`/characters/${id}`)
  },
  unlock ({ id, payType }) {
    return axios.post(`/characters/${id}/unlock`, {
      payType
    })
  }
}
